import { root, id } from './venues';

export const venues = {
  ...root,
  id,
};
